import React, { useEffect, useState } from 'react'
import {
  GET_RATED_BY_USER,
  GET_USER_RATING_BY_ID,
} from '../../../../../graphql/Catalog/UsersRating/usersRating'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { useQuery } from '@apollo/client'
import Rating from '../../../../../helpers/Rating'
import Star from '../../../../../helpers/Star'

const UserRatingInfo = ({ userId }) => {
  const [infoUser, setInfoUser] = useState({})
  const [stars, setStars] = useState([])
  const {
    data: dataRating,
    loading: loadingRating,
    error: errorRating,
  } = useQuery(GET_RATED_BY_USER, {
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    try {
      if (!userId) return
      if (loadingRating) return
      if (errorRating) throw new Error(errorRating.message)

      const userInfo = dataRating.getRatedByUser
      const splitAverage = userInfo?.average?.toString().split('.')
      userInfo.completed = parseInt(splitAverage[0])
      userInfo.decimal = splitAverage[1]
        ? parseFloat(`0.${splitAverage[1]}`) * 100
        : 0

      const starsArray = Array.from(
        { length: userInfo.completed },
        (_, index) => index + 1
      ).map((index) => {
        return {
          id: index,
          key: `star-${index}`,
          percentage: 100,
        }
      })

      if (userInfo.decimal > 0) {
        starsArray.push({
          id: starsArray.length + 1,
          key: `star-${starsArray.length + 1}`,
          percentage: userInfo.decimal.toFixed(2),
        })
      }

      if (starsArray.length < 5) {
        const remainingStars = 5 - starsArray.length
        for (let i = 0; i < remainingStars; i++) {
          starsArray.push({
            id: starsArray.length + 1 + i,
            key: `star-${starsArray.length + 1 + i}`,
            percentage: 0,
          })
        }
      }

      setStars(starsArray)
      setInfoUser(userInfo)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [dataRating, loadingRating, errorRating])

  return (
    <>
      <div
        className="star-svg"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'row',
          flexWrap: 'nowrap',
        }}
        title={`Evaluación de ${
          infoUser && infoUser.average && infoUser.average.toFixed(2)
        } de 5 \n${infoUser.totalPositiveRatings} calificaciones positivas \n${
          infoUser.totalNegativeRatings
        } calificaciones negativas`}
      >
        {stars.map((star) => (
          <div
            key={star.key}
            style={{
              display: 'inline-block',
              textAlign: 'center',
              flexShrink: 0,
              color: '#FE8E47',
            }}
          >
            <Star key={star.key} id={star.id} percentage={star.percentage} />
          </div>
        ))}
      </div>
      <p className="text-muted text-center">
        {infoUser && infoUser.average && infoUser.average.toFixed(2)} de 5
      </p>
    </>
  )
}

export default UserRatingInfo
